import { render } from "./FormToast.vue?vue&type=template&id=18f99a88"
import script from "./FormToast.vue?vue&type=script&lang=js"
export * from "./FormToast.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__